import React, { useState, useContext } from 'react';
import styled, { css } from 'styled-components';
import { ApplicationUIContext } from '@yuhuinc/ui-library';
import { useQueryClient } from '@tanstack/react-query';

import { Typography, Row, Divider, Space, Input, Button } from 'antd';
import { TagOutlined } from '@ant-design/icons';

import { apiPutRequest } from 'helpers/ApiHelper';

const { Text } = Typography;

const StyledInput = styled(Input)`
  width: ${(props) => (props.isMobile ? `100%` : `70%`)};
`;
const StyledButton = styled(Button)`
  width: ${(props) => (props.isMobile ? `100%` : `30%`)};
  height: 27px;
  ${(props) =>
    props.isMobile &&
    css`
      margin-top: 8px;
    `}
`;

const SideBarIncentives = ({ leasePricing, cotenantId, applicationWizard, isPreview }) => {
  const { isMobile } = useContext(ApplicationUIContext);
  const queryClient = useQueryClient();

  const [showIncentivesInput, setShowIncentivesInput] = useState(false);
  const [incentiveInputValue, setIncentiveInputValue] = useState('');
  const [showIncentiveError, setShowIncentiveError] = useState(false);
  const [loading, setLoading] = useState(false);

  const { prepayments } = leasePricing;
  const showIncentives = prepayments?.length > 0;

  const addIncentive = async () => {
    if (!incentiveInputValue || isPreview) return;

    try {
      setLoading(true);
      await apiPutRequest(
        `/leads/application_portal/cotenants/${cotenantId}/incentives/apply_incentive_code`,
        {
          incentive_code: incentiveInputValue,
        }
      );
      setShowIncentivesInput(false);
      setIncentiveInputValue('');
      setLoading(false);
      queryClient.invalidateQueries({ queryKey: ['cotenant', cotenantId] });
    } catch (error) {
      setLoading(false);
      setShowIncentiveError(true);
      setIncentiveInputValue('');
    }
  };

  if (!showIncentives && !applicationWizard) return <></>;

  return (
    <>
      <Divider />
      <Row justify="space-between">
        <Space>
          <TagOutlined />
          <Text strong>Incentives</Text>
        </Space>
        {applicationWizard && (
          <Space>
            <Button size="small" onClick={() => setShowIncentivesInput(!showIncentivesInput)}>
              {showIncentivesInput ? 'Cancel' : 'Add'}
            </Button>
          </Space>
        )}
      </Row>
      {showIncentivesInput && (
        <Row>
          <Space direction="vertical" size="middle">
            <Text type="secondary">Enter a promo code</Text>
            <Input.Group compact size="small">
              <StyledInput
                allowClear
                status={showIncentiveError ? 'error' : ''}
                size="small"
                isMobile={isMobile}
                value={incentiveInputValue}
                onChange={(e) => setIncentiveInputValue(e.target.value)}
              />
              <StyledButton
                loading={loading}
                type="primary"
                size="small"
                isMobile={isMobile}
                onClick={addIncentive}
              >
                Add
              </StyledButton>
            </Input.Group>
            {showIncentiveError && (
              <Text type="danger">This is not a valid promo code for this property or unit.</Text>
            )}
          </Space>
        </Row>
      )}

      {showIncentives &&
        prepayments.map((prepayment) => {
          <Row key={`incentive_${prepayment.id}`}>
            <Text type="secondary">{prepayment.incentive}</Text>
          </Row>;
        })}
    </>
  );
};

export default SideBarIncentives;
